import { parseLocaleFromStringWithDefault } from '@shared/helpers/locale.helper';
import type { CommonThirdPartyPayload } from '@shared/models/third-party-provider.model';

export const parseCommonThirdPartyPayload = (searchParams: URLSearchParams): CommonThirdPartyPayload => ({
  clientId: searchParams.get('clientId'),
  redirectUrl: searchParams.get('redirectUrl'),
  lang: parseLocaleFromStringWithDefault(searchParams.get('lang')),
});
